"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var r=require("./arrayLikeToArray.js");exports.default=function(e){if(Array.isArray(e))return r.default(e)};
